import React from 'react';
import { Drawer, List, ListItem, ListItemText, Divider, Typography, Box, ListItemIcon } from '@mui/material';
import { Work as WorkIcon } from '@mui/icons-material';
import { useState, useEffect} from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import ListItemButton from '@mui/material/ListItemButton';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import { Link } from 'react-router-dom';
import {  useParams } from 'react-router-dom';
import { HOST } from '../components/config';

const Sidebar = ({ open, onClose }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isMinimized, setIsMinimized] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');
  const { caseId } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      try {
        const response = await fetch( HOST + '/api/cases/?org_id=' + localStorage.getItem('org_id'), {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
        });
        const json = await response.json()
        if (response.status == 200)
          setData(json);
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array ensures this runs only once on mount

  if (isLoading) {
    return <div>Loading...</div>;
  }
  const filteredCaseData = search.length > 0 ? data.filter((_case) => _case.name.toLowerCase().includes(search.toLowerCase())) : data 
  const filteredCases = filteredCaseData.map((item) => {
          const date_s = new Date(item.created_at).toLocaleDateString()
          return (
      
          <ListItem sx={{ pl: 4}} key={item.id} disablePadding>
            <ListItemButton component={Link} to={"/cases/" + item.id}>
              <ListItemText primaryTypographyProps={{ style: { fontWeight: item.id == caseId ? "bold" : ''} }}  primary={item.name}  />
            </ListItemButton>
          </ListItem>

      )}) 
  const activeCase = data.filter((_case) => _case.id == caseId)[0]

  const categories = [
    {
      name: 'Cases',
      id: 'cases',
      subItems: filteredCases 
    },
  ];
  return (
    <>
    <IconButton variant = 'outlined' sx={{ m: 1,  }} onClick={()=> setIsMinimized(!isMinimized)} >
      <MenuIcon sx={{ mr: 1, color: "#fff" }} /> 
    </IconButton>
    <Drawer
      open={!isMinimized}
      onClose={() => setIsMinimized(true)}
      anchor='left'
      sx={{
        width: 350,
        background: "primary.main",
        flexShrink: 1,
        '& .MuiDrawer-paper': {
          display: "absolute",
          width: 350,
          top: 65,
          height: 'calc(100% - 65px)',
          boxSizing: 'border-box',
        },
      }}
   >

{/* Categories List with Nested Items (Always Expanded) */}
      <Box
        component="form"
        sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}
        noValidate
        autoComplete="off"
      >
      </Box>     
      <List>
        {categories.map((category) => (
          <div key={category.id}>
            {/* Category Name */}
            <ListItem>
              <TextField value={search} onChange={(e) => setSearch(e.target.value)} id="standard-basic" label="Search Cases" variant="standard" />
              
            </ListItem>

            {category.subItems} 
          </div>
        ))}
      </List>
      <Divider />
    </Drawer>
  </>
  );
};

export default Sidebar;

